import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { WalletProvider } from './lib/wallet';
import App from './App';
import {stackBase} from './lib/deployment-route';
import './styles.css';
import './terminal.css';
import './design-fidelity.css';
import './flow-layout.css';
import './market-terminal.css';
import './launchpad.css';
import './source-price-ticker.css';
import './surface-polish.css';
import './pages/asset-surfaces.css';
import './terminal-surfaces.css';
import './near-market.css';
import './oddsuit-routes.css';
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode><BrowserRouter basename={stackBase || '/'}><WalletProvider><App/></WalletProvider></BrowserRouter></React.StrictMode>);
